var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MasterDetail',{attrs:{"formTitle":"Cadastro de Terceiros","cols":_vm.cols,"opts":_vm.opts,"resourceUrl":_vm.resourceUrl,"descriptionProperty":"razao_social"}})}
var staticRenderFns = []

export { render, staticRenderFns }